/* eslint ember/no-classic-classes:"off" */
import Ember from 'ember';
import RESTAdapter from '@ember-data/adapter/rest';
export default RESTAdapter.extend({
  init(...args) {
    this._super(...args);
    this.useFetch = false;
    this._hasLoadedAll = false;
  },
  namespace: '/api/v2/multiunit/subunits',
  allUnitSuffix: '?all_merchant_units=true',
  shouldBackgroundReloadRecord: () => false,
  shouldBackgroundReloadAll: () => false,
  // The items-v3-base serializer uses `embedded: 'always'` for its
  // enabledUnits/disabledUnits hasMany relationships, which pushes a partial
  // set of merchant-subunit-ed records into the store as a side effect of
  // loading catalog items. The default shouldReloadAll returns false when
  // records already exist, so store.findAll('merchant-subunit-ed') would
  // return this incomplete set without ever fetching the full list from the
  // server. We force a reload on the first findAll to ensure we get all units.
  shouldReloadAll(store, snapshotRecordArray) {
    if (Ember.testing) {
      // Default Ember Data behavior: reload only when store is empty.
      return snapshotRecordArray.length === 0;
    }
    return !this._hasLoadedAll;
  },
  findAll(...args) {
    return this._super(...args).then(result => {
      this._hasLoadedAll = true;
      return result;
    });
  },
  pathForType() {
    return 'subunits';
  },
  urlForFindRecord(id) {
    return `${this.namespace}/${id}`;
  },
  urlForFindAll() {
    return `${this.namespace}${this.allUnitSuffix}`;
  }
});